import { type Dispatch, type SetStateAction, useState } from 'react'
import { type ConnectionLayerOptions } from '@components'

const DEFAULT_CONNECTION_SETTINGS: ConnectionLayerOptions = {
  lineType: 'dotted',
  lineShape: 'curve',
}

type Result = [ConnectionLayerOptions, Dispatch<SetStateAction<ConnectionLayerOptions>>]

const CONNECTION_SETTINGS_KEY = 'teamConnectionLayerSettings'
export const useConnectionSettings = (): Result => {
  const [connectionSettings, _setConnectionSettings] = useState<ConnectionLayerOptions>(getStoredConnectionSettings())

  const setConnectionSettings: Dispatch<SetStateAction<ConnectionLayerOptions>> = (settings) => {
    _setConnectionSettings((prev) => {
      const newSettings = typeof settings === 'function' ? settings(prev) : settings
      localStorage.setItem(CONNECTION_SETTINGS_KEY, JSON.stringify(newSettings))
      return newSettings
    })
  }

  return [connectionSettings, setConnectionSettings]
}

const getStoredConnectionSettings = (): ConnectionLayerOptions => {
  const storedSettings = localStorage.getItem(CONNECTION_SETTINGS_KEY)
  if (!storedSettings) return DEFAULT_CONNECTION_SETTINGS
  if (!isValidConnectionSettings(storedSettings)) return DEFAULT_CONNECTION_SETTINGS
  return JSON.parse(storedSettings)
}

const isValidConnectionSettings = (settings: string): boolean => {
  try {
    JSON.parse(settings)
    return true
  } catch (error) {
    return false
  }
}
